import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CompanySideBarTreeViewService } from 'app/modules/company-view/services/company-side-bar-tree-view.service';
import { ConfirmDialogModel } from 'app/modules/common/components/confirmation-dialog/confirm-dialog-model';
import { ConfirmationDialogComponent } from 'app/modules/common/components/confirmation-dialog/confirmation-dialog.component';
import { PageLoaderService } from 'app/modules/common/services/page-loader.service';
import { SharedService } from 'app/modules/common/services/shared-service';
import Utils from 'app/Utils';



@Component({
    selector: 'app-derivar-mutua',
    templateUrl: './derivar-mutua.component.html',
    styleUrls: ['./derivar-mutua.component.scss'],
    standalone: false
})
export class DerivarMutuaComponent implements OnInit {
  idEmpresa:number;
  currentUser;
  currentUserAbreviacion;
  currentUserNombre;

  constructor(
    public _dialogRef: MatDialogRef<DerivarMutuaComponent>,
    private _companySideBarTreeViewService: CompanySideBarTreeViewService,
    private _dialog: MatDialog,
    private _pageLoaderService: PageLoaderService,
    private _sharedService: SharedService,
    
  ) { }

  ngOnInit(): void {
  }

  onChangeCompany(event: any): void {
    this.idEmpresa = event.id;
  }

  close(): void {
    this._dialogRef.close();
  }

  public onSubmit() {
    this.currentUser = JSON.parse(Utils.decrypt(localStorage.getItem('currentUser'))) ;
    this.currentUserAbreviacion = this.currentUser['abreviacion'];
    this.currentUserNombre = this.currentUser['nombre'];

    const dialogData = new ConfirmDialogModel('Esta operación CERRARÁ TODAS LAS BAJAS que superen los días especificados para la empresa en Días - No permitir tarea ¿Desea continuar?', '');
    const dialogRef = this._dialog.open(ConfirmationDialogComponent, {
      data: dialogData
    });
    dialogRef.afterClosed().subscribe(response => {
      if (response) {
        this._pageLoaderService.ShowPageLoader();
        this._companySideBarTreeViewService.CloseLeavesMutua(this.idEmpresa, this.currentUserAbreviacion, this.currentUserNombre).subscribe(result => {
          if (result.result >= 0) {
            this._pageLoaderService.HidePageLoader();
            this._sharedService.ShowSnackBar('Se han cerrado ' + result.result + ' bajas correctamente', 'Okay', 2000);
            this.ngOnInit();
          } else {
            this._pageLoaderService.HidePageLoader();
            this._sharedService.ShowSnackBar('Cerrar bajas error', 'Okay', 2000);
            this.ngOnInit();
          }
        }, err => {
          console.error(err);
          this._pageLoaderService.HidePageLoader();
          this._sharedService.ShowSnackBar('API solicitud fallida', 'Okay', 2000);
        });
      }
    }
    )
    this._dialogRef.close();
    this._pageLoaderService.HidePageLoader();
  }

}
